angular.module('charts')
  .directive('dblGradesChooser', ['$timeout', '$window', function($timeout, $window) {
    return {
        restrict: 'E',
        scope: {
            dblGrades: '=',
            dblOnGradeChosen: '&'
        },
        templateUrl: '/resources/charts/directives/grades-chooser/dbl-grades-chooser.directive.html',
        link: function(scope, element) {
            // Index in dblGrades of the item desired in the center.  The item may not acutally
            // be in the center if it is near the beginning or end of the list.
            var centerIndex;
            // The current left position of the grade container relative to the scroller element
            var gradeContainerLeft;

            function centerOnGradeEle(gradeEle, animate) {
                var scrollerEle = element.find('.grades-scroller');
                var gradesContainerEle = element.find('.grades-container');
                var lastGradeEle = gradesContainerEle.find('.grade').last();

                var scrollerWidth = scrollerEle.innerWidth(); // inner width excludes margins where buttons sit

                // wanted to use grade container width for this, but couln't figure out
                // why grade container doesn't expand to full width of the elements it contains despite
                // success with similar setup in plnkr.  Might be picking up something from bootstrap.
                var gradesWidth = lastGradeEle.position().left + lastGradeEle.width();

                var gradeEleLeft = gradeEle.position().left;
                var gradeEleWidth = gradeEle.width();

                var calculatedPosition = (scrollerWidth - gradeEleWidth) / 2 - gradeEleLeft;

                // make sure calculated position isn't out of bounds
                // endMarginAllowance prevents a trivial centering of only a few pixels
                // when one end is near the last grade
                var endMarginAllowance = 10;
                var maxPosition = -endMarginAllowance;
                var minPosition = scrollerWidth - gradesWidth + endMarginAllowance;
                gradeContainerLeft = Math.max(Math.min(calculatedPosition, maxPosition), minPosition);

                if (animate) {
                    gradesContainerEle.animate({
                        left: gradeContainerLeft
                    }, 100);
                } else {
                    gradesContainerEle.css('left', gradeContainerLeft);
                }

                // disable buttons if at or over bounds (over should never actually happen)
                scope.isNextEnabled = gradeContainerLeft > minPosition;
                scope.isPreviousEnabled = gradeContainerLeft < maxPosition;

                // if all grades are visible, no need to show buttons
                scope.allGradesVisible = !scope.isNextEnabled && !scope.isPreviousEnabled;
                scope.buttonsVisible = !scope.allGradesVisible;
            }

            function centerOnIndex(newIndex, animate) {
                if (newIndex === undefined) {
                    return;
                }

                var gradesContainerEle = element.find('.grades-container');
                var newCenterEle = gradesContainerEle.children().eq(newIndex);

                if (!newCenterEle.length) {
                    return;
                }

                centerOnGradeEle(newCenterEle, animate);
                centerIndex = newIndex;
            }

            function centerOnSelected(animate) {
                var selectedIndex = _.findIndex(scope.dblGrades, function (grade) {
                    return grade.isSelected;
                });

                centerOnIndex(selectedIndex, animate);
            }

            function moveCenter(increment) {
                if (!increment || centerIndex === undefined) {
                    return;
                }

                var maxCenterIndex = scope.dblGrades ? scope.dblGrades.length - 1 : 0;
                var minCenterIndex = 0;

                if (increment > 0 && (!scope.isNextEnabled || centerIndex >= maxCenterIndex)) {
                    return;
                } else if (increment < 0 && (!scope.isPreviousEnabled || centerIndex <= minCenterIndex)) {
                    return;
                }

                // Keep incrementing center index until the control moves.  This is needed because
                // if the centerIndex is near one of the ends, the true center is in
                // a different location.
                var previousLeft;
                do {
                    previousLeft = gradeContainerLeft;
                    centerOnIndex(centerIndex + increment, true);
                } while (previousLeft === gradeContainerLeft);
            }

            function onResize() {
                if (centerIndex !== undefined) {
                    $timeout(function () {
                        centerOnIndex(centerIndex, false);
                    }, 0);
                }
            }

            function selectGrade (grade) {
                _.each(scope.dblGrades, function (dblGrade) {
                    dblGrade.isSelected = dblGrade.id === grade.id;
                });
            }

            scope.gradeClicked = function (grade) {
                selectGrade(grade);
                scope.dblOnGradeChosen({grade: grade});
            };

            scope.nextClicked = function () {
                moveCenter(1);
            };

            scope.previousClicked = function () {
                moveCenter(-1);
            };

            scope.$on('$destroy', function () {
                angular.element($window).off('resize', onResize);
            });

            scope.$watch('dblGrades', function (newVal, oldVal) {
                if (newVal && !oldVal) {
                    // timeout allows grades to render before we try to center
                    // based on element widths
                    $timeout(function () {
                        centerOnSelected(false);
                    }, 0);
                }
            });

            angular.element($window).on('resize', onResize);
        }
    };
}]);
